import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function Pricing() {
  return <section id="pricing" className="py-24 bg-brand-50 relative" data-id="element-169">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-170">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-171">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-alert-light text-alert font-bold text-sm mb-6" data-id="element-172">
            <span className="w-2 h-2 rounded-full bg-alert animate-pulse" data-id="element-173"></span>
            Oferta por tiempo limitado · Quedan pocos cupos
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 tracking-tight" data-id="element-174">
            Elegí tu opción
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto items-center" data-id="element-175">
          {/* Esencial Plan */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-3xl p-8 shadow-lg border border-gray-200" data-id="element-176">
            <div className="text-gray-500 font-bold text-lg mb-2" data-id="element-177">Esencial</div>
            <h3 className="text-2xl font-black text-gray-900 mb-2" data-id="element-178">
              MegaPack Psicopedagogía
            </h3>
            <p className="text-brand-600 font-bold mb-8" data-id="element-179">6 Tomos + 6 Bonos</p>

            <div className="mb-8" data-id="element-180">
              <div className="text-gray-400 line-through text-xl font-medium mb-1" data-id="element-181">
                $64.990
              </div>
              <div className="text-5xl font-black text-gray-900" data-id="element-182">$19.990</div>
            </div>

            <button className="w-full bg-gray-100 hover:bg-gray-200 text-gray-900 font-bold py-4 px-6 rounded-xl transition-colors mb-6" data-id="element-183">
              QUIERO MI MEGAPACK
            </button>
          </motion.div>

          {/* Completo PRO Plan */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-3xl p-8 shadow-2xl border-4 border-brand-600 relative transform md:scale-105 z-10" data-id="element-184">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-accent text-white font-black px-6 py-1.5 rounded-full text-sm uppercase tracking-wider shadow-md" data-id="element-185">
              La más elegida
            </div>

            <div className="text-brand-600 font-bold text-lg mb-2" data-id="element-186">
              Completo
            </div>
            <h3 className="text-2xl font-black text-gray-900 mb-2" data-id="element-187">
              MegaPack Psicopedagogía + KIT PROFESIONAL
            </h3>
            <p className="text-brand-600 font-bold mb-6" data-id="element-188">
              6 Tomos + 6 Bonos + 6 Módulos 💥
            </p>

            <div className="mb-6" data-id="element-189">
              <div className="text-gray-400 line-through text-xl font-medium mb-1" data-id="element-190">
                $93.990
              </div>
              <div className="text-5xl font-black text-gray-900" data-id="element-191">$27.990</div>
            </div>

            <div className="bg-brand-50 rounded-xl p-4 mb-6 border border-brand-100" data-id="element-192">
              <p className="text-sm text-brand-800 font-medium mb-3" data-id="element-193">
                Por solo <strong data-id="element-194">$8.000 más</strong>, sumás todo el material PRO
                listo para usar en dislexia, TDAH y lectoescritura.
              </p>
              <div className="flex flex-wrap gap-2" data-id="element-195">
                <span className="text-xs font-bold bg-white px-2 py-1 rounded text-gray-700 shadow-sm border border-gray-100" data-id="element-196">
                  🧠 Memoria PRO
                </span>
                <span className="text-xs font-bold bg-white px-2 py-1 rounded text-gray-700 shadow-sm border border-gray-100" data-id="element-197">
                  🎯 Atención PRO
                </span>
                <span className="text-xs font-bold bg-white px-2 py-1 rounded text-gray-700 shadow-sm border border-gray-100" data-id="element-198">
                  🗣️ Lenguaje PRO
                </span>
                <span className="text-xs font-bold bg-white px-2 py-1 rounded text-gray-700 shadow-sm border border-gray-100" data-id="element-199">
                  📖 Lectoescritura PRO
                </span>
                <span className="text-xs font-bold bg-white px-2 py-1 rounded text-gray-700 shadow-sm border border-gray-100" data-id="element-200">
                  🔢 Lógica Mat. PRO
                </span>
                <span className="text-xs font-bold bg-white px-2 py-1 rounded text-gray-700 shadow-sm border border-gray-100" data-id="element-201">
                  🧩 F. Ejecutivas PRO
                </span>
              </div>
            </div>

            <button className="w-full bg-brand-600 hover:bg-brand-700 text-white font-black py-5 px-6 rounded-xl transition-all transform hover:-translate-y-1 shadow-lg hover:shadow-brand-600/30 text-lg" data-id="element-202">
              QUIERO EL PLAN PRO 💥
            </button>
          </motion.div>
        </div>
      </div>
    </section>;
}